import { useState } from "react";
import { supabase } from "./supabase";

var C = {
  bg:"#0F1117", surface:"#1A1D27", surfaceHi:"#1E2230", inputBg:"#13151F",
  border:"#2E3248", accent:"#F5A623", accentDim:"rgba(245,166,35,0.1)",
  blue:"#4A90D9", blueDim:"rgba(74,144,217,0.1)", teal:"#38BFA1", tealDim:"rgba(56,191,161,0.1)",
  success:"#4CAF6E", successDim:"rgba(76,175,110,0.1)",
  danger:"#E05C5C", dangerDim:"rgba(224,92,92,0.1)",
  purple:"#9B72D0", purpleDim:"rgba(155,114,208,0.1)",
  amber:"#F5A623", text:"#E8EAF0", dim:"#9AA0C0", muted:"#6B7094",
};
var FM = { fontFamily:"'DM Mono','Courier New',monospace" };
var lbl = { fontSize:10, color:"#6B7094", letterSpacing:"0.12em", textTransform:"uppercase", fontWeight:600, fontFamily:"'DM Mono','Courier New',monospace", display:"block", marginBottom:6 };
var inp = { background:"#13151F", border:"1px solid #2E3248", borderRadius:8, padding:"11px 13px", color:"#E8EAF0", fontSize:13, fontFamily:"'DM Mono','Courier New',monospace", outline:"none", width:"100%", boxSizing:"border-box" };

// Stripe Price IDs
var STRIPE_PRICES = {
  starter: { monthly:"price_1TVMs21gK47wucI8ApDvHpcq", annual:"price_1TVMzP1gK47wucI8Y3KYqjzV" },
  captain: { monthly:"price_1TVMuB1gK47wucI8A5t8WoGU", annual:"price_1TVN1I1gK47wucI8QHLL0uqX" },
  pro:     { monthly:"price_1TVMwc1gK47wucI8cUJZTf4x", annual:"price_1TVN441gK47wucI8LuE7cqHf" },
};

function startCheckout(planId, billing, user, isFounder) {
  var prices = STRIPE_PRICES[planId];
  if (!prices) return;
  var priceId = billing==="annual" ? prices.annual : prices.monthly;
  fetch("/.netlify/functions/create-checkout", {
    method:"POST",
    headers:{"Content-Type":"application/json"},
    body:JSON.stringify({
      priceId:   priceId,
      email:     user.email||"",
      userId:    user.id||"",
      companyId: user.company_id||"",
      isFounder: isFounder||false,
    })
  })
  .then(function(r){ return r.json(); })
  .then(function(data){
    if (data.url) window.location.href = data.url;
    else alert("Checkout failed. Please try again.");
  })
  .catch(function(){ alert("Checkout failed. Check your connection."); });
}

var PLANS = {
  free:    { id:"free",    name:"Free",           monthlyPrice:0,     annualPrice:0,   maxUsers:1,    maxEquipment:3,  features:["1 user","3 equipment","Manual entry only","Basic maintenance tracking"] },
  starter: { id:"starter", name:"One Man Band",   monthlyPrice:19.99, annualPrice:199, maxUsers:1,    maxEquipment:10, features:["1 user","10 equipment","All features","VIN lookup","Service requests","Weekly reports"] },
  captain: { id:"captain", name:"Captain & Crew", monthlyPrice:39.99, annualPrice:399, maxUsers:5,    maxEquipment:25, features:["1 admin + 4 crew","25 equipment","All features","Priority support"] },
  pro:     { id:"pro",     name:"Pro",             monthlyPrice:79.99, annualPrice:799, maxUsers:null, maxEquipment:null, features:["Unlimited users & equipment","Everything in Captain & Crew","Early access"] },
};
var FOUNDING_TOTAL = 10;

function fmtDate(iso) {
  if (!iso) return "--";
  var d = new Date(iso+"T00:00:00");
  return d.toLocaleDateString("en-US",{month:"short",day:"numeric",year:"numeric"});
}

function Field(props) {
  var s1=useState(false); var focused=s1[0]; var setFocused=s1[1];
  return (
    <div style={{ marginBottom:14 }}>
      {props.label && <label style={lbl}>{props.label}</label>}
      <input
        style={{ ...inp, borderColor:focused?C.accent:C.border }}
        type={props.type||"text"}
        value={props.value}
        onChange={props.onChange}
        placeholder={props.placeholder||""}
        onFocus={function(){ setFocused(true); }}
        onBlur={function(){ setFocused(false); }}
        disabled={props.disabled}
      />
      {props.hint && <div style={{ fontSize:10, color:C.muted, marginTop:4, ...FM }}>{props.hint}</div>}
    </div>
  );
}

function SaveBar(props) {
  if (!props.dirty) return null;
  return (
    <div style={{ position:"fixed", bottom:0, left:0, right:0, background:C.surface, borderTop:"1px solid "+C.border, padding:"12px 20px", display:"flex", gap:10, zIndex:50, maxWidth:480, margin:"0 auto", boxSizing:"border-box" }}>
      <button onClick={props.onDiscard} style={{ flex:1, background:"none", border:"1px solid "+C.border, borderRadius:10, color:C.muted, fontSize:12, ...FM, padding:12, cursor:"pointer", textTransform:"uppercase", letterSpacing:"0.08em" }}>Discard</button>
      <button onClick={props.onSave} style={{ flex:2, background:C.accent, border:"none", borderRadius:10, color:"#0F1117", fontSize:12, ...FM, fontWeight:700, padding:12, cursor:"pointer", textTransform:"uppercase", letterSpacing:"0.08em" }}>Save Changes</button>
    </div>
  );
}

// ─── COMPANY PROFILE TAB ─────────────────────────────────────────────────────

function CompanyTab(props) {
  var account=props.account; var onSave=props.onSave;
  var f1=useState(account.companyName||""); var companyName=f1[0]; var setCompanyName=f1[1];
  var f2=useState(account.industry||"");    var industry=f2[0];    var setIndustry=f2[1];
  var f3=useState(account.phone||"");       var phone=f3[0];       var setPhone=f3[1];
  var f4=useState(account.address||"");     var address=f4[0];     var setAddress=f4[1];
  var f5=useState(account.city||"");        var city=f5[0];        var setCity=f5[1];
  var f6=useState(account.state||"");       var state=f6[0];       var setState=f6[1];
  var f7=useState(account.zip||"");         var zip=f7[0];         var setZip=f7[1];
  var f8=useState(account.timezone||"America/Denver"); var tz=f8[0]; var setTz=f8[1];

  var INDUSTRIES = [
    {v:"landscaping",l:"Landscaping & Grounds"},
    {v:"excavation",l:"Excavation & Construction"},
    {v:"agriculture",l:"Farm & Ranch"},
    {v:"rental",l:"Equipment Rental"},
    {v:"other",l:"Other"},
  ];
  var TIMEZONES = ["America/New_York","America/Chicago","America/Denver","America/Los_Angeles","America/Phoenix","America/Anchorage","Pacific/Honolulu"];

  var dirty = companyName!==account.companyName||industry!==account.industry||phone!==account.phone||address!==account.address||city!==account.city||state!==account.state||zip!==account.zip||tz!==account.timezone;

  function doSave() {
    onSave(Object.assign({},account,{companyName:companyName.trim(),industry:industry,phone:phone.trim(),address:address.trim(),city:city.trim(),state:state.trim(),zip:zip.trim(),timezone:tz}));
  }

  return (
    <div style={{ paddingBottom:80 }}>
      <div style={{ background:C.surface, border:"1px solid "+C.border, borderRadius:14, padding:"18px 16px", marginBottom:12 }}>
        <div style={{ fontSize:11, color:C.accent, fontWeight:700, letterSpacing:"0.15em", textTransform:"uppercase", marginBottom:14 }}>Company Info</div>
        <Field label="Company / Operation Name" value={companyName} onChange={function(e){ setCompanyName(e.target.value); }} placeholder="Green Ridge Lawn Care" />
        <div style={{ marginBottom:14 }}>
          <label style={lbl}>Industry</label>
          <select value={industry} onChange={function(e){ setIndustry(e.target.value); }} style={{ ...inp, appearance:"none", cursor:"pointer" }}>
            <option value="">Select industry...</option>
            {INDUSTRIES.map(function(i){ return <option key={i.v} value={i.v}>{i.l}</option>; })}
          </select>
        </div>
        <Field label="Phone" type="tel" value={phone} onChange={function(e){ setPhone(e.target.value); }} placeholder="(208) 555-0100" />
      </div>
      <div style={{ background:C.surface, border:"1px solid "+C.border, borderRadius:14, padding:"18px 16px", marginBottom:12 }}>
        <div style={{ fontSize:11, color:C.teal, fontWeight:700, letterSpacing:"0.15em", textTransform:"uppercase", marginBottom:14 }}>Location</div>
        <Field label="Street Address" value={address} onChange={function(e){ setAddress(e.target.value); }} placeholder="123 Main St" />
        <div style={{ display:"flex", gap:10, marginBottom:14 }}>
          <div style={{ flex:2 }}><label style={lbl}>City</label><input style={inp} value={city} onChange={function(e){ setCity(e.target.value); }} placeholder="Tetonia" /></div>
          <div style={{ flex:1 }}><label style={lbl}>State</label><input style={inp} value={state} onChange={function(e){ setState(e.target.value); }} placeholder="ID" maxLength={2} /></div>
          <div style={{ flex:1 }}><label style={lbl}>ZIP</label><input style={inp} value={zip} onChange={function(e){ setZip(e.target.value); }} placeholder="83452" /></div>
        </div>
        <div>
          <label style={lbl}>Timezone</label>
          <select value={tz} onChange={function(e){ setTz(e.target.value); }} style={{ ...inp, appearance:"none", cursor:"pointer" }}>
            {TIMEZONES.map(function(t){ return <option key={t} value={t}>{t.replace("America/","").replace("Pacific/","Pacific — ").replace("_"," ")}</option>; })}
          </select>
        </div>
      </div>
      <SaveBar dirty={dirty} onSave={doSave} onDiscard={function(){ setCompanyName(account.companyName||""); setIndustry(account.industry||""); setPhone(account.phone||""); setAddress(account.address||""); setCity(account.city||""); setState(account.state||""); setZip(account.zip||""); setTz(account.timezone||"America/Denver"); }} />
    </div>
  );
}

// ─── ACCOUNT TAB ─────────────────────────────────────────────────────────────

function AccountTab(props) {
  var account=props.account; var onSave=props.onSave; var onDeleteAccount=props.onDeleteAccount;
  var f1=useState(account.ownerName||"");  var ownerName=f1[0];  var setOwnerName=f1[1];
  var f2=useState(account.email||"");      var email=f2[0];      var setEmail=f2[1];
  var f3=useState("");                     var newPw=f3[0];       var setNewPw=f3[1];
  var f4=useState("");                     var confirmPw=f4[0];   var setConfirmPw=f4[1];
  var f5=useState(false);                  var showDelete=f5[0];  var setShowDelete=f5[1];
  var f6=useState("");                     var deleteInput=f6[0]; var setDeleteInput=f6[1];
  var f7=useState(false);                  var pwSaved=f7[0];     var setPwSaved=f7[1];
  var f8=useState(null);                   var pwError=f8[0];     var setPwError=f8[1];

  var dirty = ownerName!==account.ownerName||email!==account.email;
  var pwReady = newPw.length>=8 && newPw===confirmPw;

  function doSave() {
    onSave(Object.assign({},account,{ownerName:ownerName.trim(),email:email.trim()}));
  }

  function savePassword() {
    if (newPw.length<8) { setPwError("Password must be at least 8 characters"); return; }
    if (newPw!==confirmPw) { setPwError("Passwords do not match"); return; }
    setPwError(null); setPwSaved(true); setNewPw(""); setConfirmPw("");
    setTimeout(function(){ setPwSaved(false); }, 3000);
  }

  return (
    <div style={{ paddingBottom:80 }}>
      {/* Delete confirm modal */}
      {showDelete && (
        <div style={{ position:"fixed", top:0, right:0, bottom:0, left:0, background:"rgba(0,0,0,0.88)", display:"flex", alignItems:"center", justifyContent:"center", zIndex:500, padding:20 }}>
          <div style={{ background:C.surface, border:"1px solid "+C.danger, borderRadius:16, padding:"28px 24px", maxWidth:400, width:"100%" }}>
            <div style={{ fontSize:16, fontWeight:700, color:C.danger, marginBottom:8 }}>Delete Account</div>
            <div style={{ fontSize:13, color:C.dim, marginBottom:20, lineHeight:1.7 }}>
              This will permanently delete your account, all equipment records, maintenance history, and logs. <span style={{ color:C.danger, fontWeight:700 }}>This cannot be undone.</span>
            </div>
            <div style={{ marginBottom:20 }}>
              <label style={{ ...lbl, color:C.danger }}>Type DELETE to confirm</label>
              <input
                style={{ ...inp, borderColor:deleteInput==="DELETE"?C.danger:C.border, color:C.danger, fontWeight:700, letterSpacing:"0.15em" }}
                value={deleteInput}
                onChange={function(e){ setDeleteInput(e.target.value.toUpperCase()); }}
                placeholder="DELETE"
                autoFocus
              />
            </div>
            <div style={{ display:"flex", gap:10 }}>
              <button onClick={function(){ setShowDelete(false); setDeleteInput(""); }} style={{ flex:1, background:"none", border:"1px solid "+C.border, borderRadius:10, color:C.muted, fontSize:12, ...FM, padding:12, cursor:"pointer" }}>Cancel</button>
              <button
                disabled={deleteInput!=="DELETE"}
                onClick={function(){ if(deleteInput==="DELETE") onDeleteAccount(); }}
                style={{ flex:1, background:deleteInput==="DELETE"?C.danger:C.surfaceHi, border:"none", borderRadius:10, color:deleteInput==="DELETE"?"#fff":C.muted, fontSize:12, ...FM, fontWeight:700, padding:12, cursor:deleteInput==="DELETE"?"pointer":"not-allowed" }}
              >
                Delete Forever
              </button>
            </div>
          </div>
        </div>
      )}

      <div style={{ background:C.surface, border:"1px solid "+C.border, borderRadius:14, padding:"18px 16px", marginBottom:12 }}>
        <div style={{ fontSize:11, color:C.accent, fontWeight:700, letterSpacing:"0.15em", textTransform:"uppercase", marginBottom:14 }}>Account Owner</div>
        <Field label="Full Name" value={ownerName} onChange={function(e){ setOwnerName(e.target.value); }} placeholder="Mike Caufield" />
        <Field label="Email Address" type="email" value={email} onChange={function(e){ setEmail(e.target.value); }} placeholder="you@yourcompany.com" />
      </div>

      <div style={{ background:C.surface, border:"1px solid "+C.border, borderRadius:14, padding:"18px 16px", marginBottom:12 }}>
        <div style={{ fontSize:11, color:C.blue, fontWeight:700, letterSpacing:"0.15em", textTransform:"uppercase", marginBottom:14 }}>Change Password</div>
        <Field label="New Password" type="password" value={newPw} onChange={function(e){ setNewPw(e.target.value); setPwError(null); }} placeholder="8+ characters" />
        <Field label="Confirm Password" type="password" value={confirmPw} onChange={function(e){ setConfirmPw(e.target.value); setPwError(null); }} placeholder="Repeat password" />
        {pwError && <div style={{ fontSize:11, color:C.danger, marginBottom:10, ...FM }}>{pwError}</div>}
        {pwSaved && <div style={{ fontSize:11, color:C.success, marginBottom:10, ...FM }}>Password updated.</div>}
        <button disabled={!pwReady} onClick={savePassword} style={{ width:"100%", background:pwReady?C.blue:C.surfaceHi, border:"none", borderRadius:10, color:pwReady?"#fff":C.muted, fontSize:12, ...FM, fontWeight:700, padding:11, cursor:pwReady?"pointer":"not-allowed", textTransform:"uppercase", letterSpacing:"0.08em" }}>Update Password</button>
      </div>

      <div style={{ background:C.dangerDim, border:"1px solid "+C.danger, borderRadius:14, padding:"18px 16px", marginBottom:12 }}>
        <div style={{ fontSize:11, color:C.danger, fontWeight:700, letterSpacing:"0.15em", textTransform:"uppercase", marginBottom:8 }}>Danger Zone</div>
        <div style={{ fontSize:12, color:C.dim, marginBottom:14, lineHeight:1.6 }}>Permanently delete your ChoreHabit account and all associated data. This action cannot be reversed.</div>
        <button onClick={function(){ setShowDelete(true); }} style={{ width:"100%", background:"none", border:"1px solid "+C.danger, borderRadius:10, color:C.danger, fontSize:12, ...FM, fontWeight:700, padding:11, cursor:"pointer", textTransform:"uppercase", letterSpacing:"0.08em" }}>Delete Account</button>
      </div>

      <SaveBar dirty={dirty} onSave={doSave} onDiscard={function(){ setOwnerName(account.ownerName||""); setEmail(account.email||""); }} />
    </div>
  );
}

// ─── SUBSCRIPTION TAB ─────────────────────────────────────────────────────────

function SubscriptionTab(props) {
  var account=props.account; var onSave=props.onSave;
  var currentUser=props.currentUser||{};
  var s1=useState(account.billing||"monthly"); var billingCycle=s1[0]; var setBillingCycle=s1[1];
  var s2=useState(null);  var activeSheet=s2[0]; var setActiveSheet=s2[1];
  var s3=useState(false); var showCancel=s3[0];  var setShowCancel=s3[1];
  var s4=useState(false); var copied=s4[0];      var setCopied=s4[1];
  var s5=useState("");    var referralInput=s5[0];var setReferralInput=s5[1];
  var s6=useState(null);  var referralMsg=s6[0]; var setReferralMsg=s6[1];
  var s7=useState(null);  var liveSpots=s7[0];   var setLiveSpots=s7[1];
  var s7l=useState(false);var spotsLoaded=s7l[0];var setSpotsLoaded=s7l[1];

  // Fetch live founding member count
  if (!spotsLoaded) {
    setSpotsLoaded(true);
    fetch("https://cvdyjtadwcdzygrbftkb.supabase.co/rest/v1/companies?is_test_account=eq.false&is_founding_member=eq.true&select=id", {
      headers: {
        "apikey": "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImN2ZHlqdGFkd2NkenlncmJmdGtiIiwicm9sZSI6ImFub24iLCJpYXQiOjE3Nzc0NTA3MDAsImV4cCI6MjA5MzAyNjcwMH0.0wHgMynLBwWRCvXdk_CBwpmZyqNdKksKV7OqStdTlAw",
        "Authorization": "Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImN2ZHlqdGFkd2NkenlncmJmdGtiIiwicm9sZSI6ImFub24iLCJpYXQiOjE3Nzc0NTA3MDAsImV4cCI6MjA5MzAyNjcwMH0.0wHgMynLBwWRCvXdk_CBwpmZyqNdKksKV7OqStdTlAw"
      }
    })
    .then(function(r){ return r.json(); })
    .then(function(data){ if(Array.isArray(data)) setLiveSpots(Math.max(0, 10-data.length)); })
    .catch(function(){});
  }

  var plan = PLANS[account.plan]||PLANS.free;
  var isFounder = account.isFoundingMember;
  var discount = isFounder ? 0.5 : 0;
  var foundingSpotsLeft = liveSpots !== null ? liveSpots : (account.foundingSpotsLeft||3);

  function calcBill(planId, cycle) {
    var p=PLANS[planId]; if (!p||p.id==="free") return 0;
    var base = cycle==="annual" ? p.annualPrice/12 : p.monthlyPrice;
    return isFounder ? base*0.5 : base;
  }
  var monthlyBill = calcBill(account.plan, account.billing||"monthly");

  function copyReferral() { setCopied(true); setTimeout(function(){ setCopied(false); },2000); }

  function applyReferral() {
    if (!referralInput.trim()) { setReferralMsg({type:"error",text:"Enter a referral code."}); return; }
    if (referralInput.trim().toUpperCase()==="FLEET50") { setReferralMsg({type:"success",text:"Code applied! 50% off your first month."}); }
    else { setReferralMsg({type:"error",text:"Code not found. Check with the person who referred you."}); }
  }

  return (
    <div style={{ paddingBottom:60 }}>
      {/* Upgrade sheet */}
      {activeSheet==="upgrade" && (
        <div style={{ position:"fixed", top:0, right:0, bottom:0, left:0, background:"rgba(0,0,0,0.88)", display:"flex", alignItems:"flex-end", justifyContent:"center", zIndex:400 }} onClick={function(){ setActiveSheet(null); }}>
          <div style={{ background:C.surface, border:"1px solid "+C.accent, borderRadius:"16px 16px 0 0", width:"100%", maxWidth:480, maxHeight:"92vh", display:"flex", flexDirection:"column", paddingBottom:32 }} onClick={function(e){ e.stopPropagation(); }}>
            <div style={{ width:36, height:4, background:C.border, borderRadius:2, margin:"12px auto 0", flexShrink:0 }} />
            <div style={{ padding:"16px 20px 14px", borderBottom:"1px solid "+C.border, flexShrink:0 }}>
              <div style={{ fontSize:11, fontWeight:700, color:C.accent, letterSpacing:"0.18em", textTransform:"uppercase" }}>Change Plan</div>
            </div>
            <div style={{ overflowY:"auto", flex:1, padding:"16px 20px" }}>
              {/* Billing toggle */}
              <div style={{ display:"flex", background:C.inputBg, borderRadius:10, overflow:"hidden", marginBottom:20, border:"1px solid "+C.border }}>
                {["monthly","annual"].map(function(cycle) {
                  var sel=billingCycle===cycle;
                  return <button key={cycle} onClick={function(){ setBillingCycle(cycle); }} style={{ flex:1, background:sel?C.accent:"transparent", border:"none", color:sel?"#0F1117":C.muted, fontSize:12, ...FM, fontWeight:sel?700:400, padding:"11px 8px", cursor:"pointer", textTransform:"uppercase", letterSpacing:"0.08em" }}>{cycle==="monthly"?"Monthly":"Annual — 2 months free"}</button>;
                })}
              </div>
              {Object.keys(PLANS).map(function(pid) {
                var p=PLANS[pid]; var isCurrent=account.plan===pid;
                var base = billingCycle==="annual" ? p.annualPrice/12 : p.monthlyPrice;
                var shown = isFounder&&pid!=="free" ? base*0.5 : base;
                return (
                  <div key={pid} style={{ background:isCurrent?C.accentDim:C.surfaceHi, border:"1.5px solid "+(isCurrent?C.accent:C.border), borderRadius:14, padding:"18px 20px", marginBottom:12 }}>
                    <div style={{ display:"flex", justifyContent:"space-between", alignItems:"flex-start", marginBottom:10 }}>
                      <div>
                        <div style={{ fontSize:15, fontWeight:700, color:C.text }}>{p.name}</div>
                        {isCurrent && <div style={{ fontSize:10, color:C.accent, fontWeight:700, textTransform:"uppercase", letterSpacing:"0.1em", marginTop:2 }}>Current Plan</div>}
                      </div>
                      <div style={{ textAlign:"right" }}>
                        {isFounder&&pid!=="free" && <div style={{ fontSize:10, color:C.muted, textDecoration:"line-through" }}>${base.toFixed(0)}/mo</div>}
                        <div style={{ fontSize:20, fontWeight:700, color:pid==="free"?C.success:C.accent }}>{pid==="free"?"Free":"$"+shown.toFixed(0)+"/mo"}</div>
                      </div>
                    </div>
                    <div style={{ display:"flex", flexDirection:"column", gap:4, marginBottom:12 }}>
                      {p.features.map(function(f){ return <div key={f} style={{ fontSize:11, color:C.dim }}><span style={{ color:C.success }}>✓ </span>{f}</div>; })}
                    </div>
                    {!isCurrent && (
                      <button onClick={function(){
                        if (pid==="free") {
                          onSave(Object.assign({},account,{plan:pid,billing:billingCycle}));
                          setActiveSheet(null);
                        } else {
                          startCheckout(pid, billingCycle, currentUser, isFounder);
                        }
                      }} style={{ width:"100%", background:pid==="free"?C.surfaceHi:C.accent, border:"1px solid "+(pid==="free"?C.border:C.accent), borderRadius:10, color:pid==="free"?C.dim:"#0F1117", fontSize:12, ...FM, fontWeight:700, padding:11, cursor:"pointer", textTransform:"uppercase", letterSpacing:"0.08em" }}>
                        {pid==="free"?"Downgrade to Free":account.plan==="pro"?"Downgrade to "+p.name:"Upgrade to "+p.name}
                      </button>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      )}

      {/* Cancel confirm */}
      {showCancel && (
        <div style={{ position:"fixed", top:0, right:0, bottom:0, left:0, background:"rgba(0,0,0,0.88)", display:"flex", alignItems:"center", justifyContent:"center", zIndex:400, padding:20 }}>
          <div style={{ background:C.surface, border:"1px solid "+C.danger, borderRadius:16, padding:"28px 24px", maxWidth:400, width:"100%" }}>
            <div style={{ fontSize:15, fontWeight:700, color:C.danger, marginBottom:8 }}>Cancel Subscription?</div>
            {isFounder && <div style={{ background:C.dangerDim, border:"1px solid "+C.danger, borderRadius:8, padding:"10px 14px", fontSize:12, color:C.danger, marginBottom:16, lineHeight:1.6 }}>Warning: You are a Founding Member. Canceling forfeits your 50% lifetime discount permanently.</div>}
            <div style={{ fontSize:13, color:C.dim, marginBottom:20, lineHeight:1.6 }}>Your account moves to Free at the end of your billing period. All data is preserved.</div>
            <div style={{ display:"flex", gap:10 }}>
              <button onClick={function(){ setShowCancel(false); }} style={{ flex:1, background:"none", border:"1px solid "+C.border, borderRadius:10, color:C.muted, fontSize:12, ...FM, padding:12, cursor:"pointer" }}>Keep Plan</button>
              <button onClick={function(){ onSave(Object.assign({},account,{plan:"free",isFoundingMember:false})); setShowCancel(false); }} style={{ flex:1, background:C.danger, border:"none", borderRadius:10, color:"#fff", fontSize:12, ...FM, fontWeight:700, padding:12, cursor:"pointer" }}>Yes, Cancel</button>
            </div>
          </div>
        </div>
      )}

      {/* Founding member badge */}
      {isFounder && (
        <div style={{ background:"linear-gradient(135deg, rgba(245,166,35,0.15), rgba(245,166,35,0.05))", border:"1px solid "+C.accent, borderRadius:14, padding:"14px 18px", marginBottom:12, display:"flex", alignItems:"center", gap:14 }}>
          <div style={{ fontSize:28 }}>⭐</div>
          <div>
            <div style={{ fontSize:13, fontWeight:700, color:C.accent }}>Founding Member</div>
            <div style={{ fontSize:11, color:C.dim, marginTop:2, lineHeight:1.5 }}>50% off for life — stays active as long as your subscription is continuous.</div>
          </div>
        </div>
      )}
      {!isFounder && foundingSpotsLeft>0 && (
        <div style={{ background:C.accentDim, border:"1px solid "+C.accent, borderRadius:14, padding:"14px 18px", marginBottom:12 }}>
          <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:8 }}>
            <div style={{ fontSize:13, fontWeight:700, color:C.accent }}>Founding Member Spots</div>
            <div style={{ background:C.accent, borderRadius:20, padding:"3px 12px", fontSize:12, fontWeight:700, color:"#0F1117" }}>{foundingSpotsLeft} left</div>
          </div>
          <div style={{ display:"flex", gap:3, marginBottom:10 }}>
            {Array.from({length:FOUNDING_TOTAL}).map(function(_,i){ var taken=i<(FOUNDING_TOTAL-foundingSpotsLeft); return <div key={i} style={{ flex:1, height:5, borderRadius:2, background:taken?C.accent:C.border }} />; })}
          </div>
          <div style={{ fontSize:11, color:C.dim, marginBottom:10, lineHeight:1.5 }}>First {FOUNDING_TOTAL} paying customers get 50% off for life. {foundingSpotsLeft} spot{foundingSpotsLeft!==1?"s":""} remaining.</div>
          <button onClick={function(){ setActiveSheet("upgrade"); }} style={{ width:"100%", background:C.accent, border:"none", borderRadius:10, color:"#0F1117", fontSize:12, ...FM, fontWeight:700, padding:11, cursor:"pointer", textTransform:"uppercase", letterSpacing:"0.08em" }}>Lock In My Spot Now</button>
        </div>
      )}

      {/* Current plan */}
      <div style={{ background:C.surface, border:"1px solid "+C.border, borderRadius:14, padding:"18px 20px", marginBottom:12 }}>
        <div style={{ display:"flex", justifyContent:"space-between", alignItems:"flex-start", marginBottom:14 }}>
          <div>
            <div style={{ fontSize:11, color:C.muted, textTransform:"uppercase", letterSpacing:"0.1em" }}>Current Plan</div>
            <div style={{ fontSize:22, fontWeight:700, color:C.text, marginTop:4 }}>{plan.name}</div>
            {isFounder && <div style={{ fontSize:11, color:C.success, marginTop:2 }}>Founding Member — 50% off</div>}
          </div>
          <div style={{ textAlign:"right" }}>
            <div style={{ fontSize:24, fontWeight:700, color:account.plan==="free"?C.success:C.accent }}>{account.plan==="free"?"Free":"$"+monthlyBill.toFixed(0)+"/mo"}</div>
            {account.plan!=="free" && <div style={{ fontSize:10, color:C.muted, marginTop:2 }}>{(account.billing||"monthly")==="annual"?"billed annually":"billed monthly"}</div>}
            {account.plan!=="free" && <div style={{ fontSize:11, color:C.muted, marginTop:2 }}>Next: {fmtDate(account.nextBillingDate)}</div>}
          </div>
        </div>
        <div style={{ display:"flex", gap:8 }}>
          <button onClick={function(){ setActiveSheet("upgrade"); }} style={{ flex:1, background:C.accentDim, border:"1px solid "+C.accent, borderRadius:10, color:C.accent, fontSize:11, ...FM, fontWeight:700, padding:10, cursor:"pointer", textTransform:"uppercase", letterSpacing:"0.06em" }}>Change Plan</button>
          {account.plan!=="free" && <button onClick={function(){ onSave(Object.assign({},account,{billing:(account.billing||"monthly")==="monthly"?"annual":"monthly"})); }} style={{ flex:1, background:C.surfaceHi, border:"1px solid "+C.border, borderRadius:10, color:C.dim, fontSize:11, ...FM, fontWeight:700, padding:10, cursor:"pointer", textTransform:"uppercase", letterSpacing:"0.06em" }}>Switch to {(account.billing||"monthly")==="monthly"?"Annual":"Monthly"}</button>}
        </div>
      </div>

      {/* Payment method */}
      {account.plan!=="free" && (
        <div style={{ background:C.surface, border:"1px solid "+C.border, borderRadius:14, padding:"18px 20px", marginBottom:12 }}>
          <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center" }}>
            <div>
              <div style={{ fontSize:13, fontWeight:700, color:C.text }}>Payment Method</div>
              <div style={{ fontSize:11, color:C.muted, marginTop:3 }}>Visa ending in 4242</div>
            </div>
            <button style={{ background:C.surfaceHi, border:"1px solid "+C.border, borderRadius:8, color:C.dim, fontSize:11, ...FM, fontWeight:700, padding:"6px 14px", cursor:"pointer" }}>Update</button>
          </div>
        </div>
      )}

      {/* Referral */}
      <div style={{ background:C.surface, border:"1px solid "+C.border, borderRadius:14, padding:"18px 20px", marginBottom:12 }}>
        <div style={{ fontSize:13, fontWeight:700, color:C.text, marginBottom:4 }}>Referral Program</div>
        <div style={{ fontSize:11, color:C.muted, marginBottom:14, lineHeight:1.6 }}>Refer a friend — they get 50% off their first month, you get 50% off your next bill.</div>
        <div style={{ fontSize:11, color:C.dim, marginBottom:6, textTransform:"uppercase", letterSpacing:"0.1em", fontWeight:700 }}>Your Code</div>
        <div style={{ display:"flex", gap:8, marginBottom:14 }}>
          <div style={{ flex:1, background:C.inputBg, border:"1px solid "+C.border, borderRadius:8, padding:"10px 14px", fontSize:14, fontWeight:700, color:C.accent, letterSpacing:"0.15em" }}>{account.referralCode||"--"}</div>
          <button onClick={copyReferral} style={{ background:copied?C.successDim:C.accentDim, border:"1px solid "+(copied?C.success:C.accent), borderRadius:8, color:copied?C.success:C.accent, fontSize:11, ...FM, fontWeight:700, padding:"0 16px", cursor:"pointer", flexShrink:0 }}>{copied?"Copied!":"Copy"}</button>
        </div>
        <div style={{ fontSize:11, color:C.dim, marginBottom:6, textTransform:"uppercase", letterSpacing:"0.1em", fontWeight:700 }}>Have a Code?</div>
        <div style={{ display:"flex", gap:8 }}>
          <input style={{ ...inp, flex:1 }} placeholder="Enter code..." value={referralInput} onChange={function(e){ setReferralInput(e.target.value); setReferralMsg(null); }} />
          <button onClick={applyReferral} style={{ background:C.purpleDim, border:"1px solid "+C.purple, borderRadius:8, color:C.purple, fontSize:11, ...FM, fontWeight:700, padding:"0 16px", cursor:"pointer", flexShrink:0 }}>Apply</button>
        </div>
        {referralMsg && <div style={{ fontSize:11, color:referralMsg.type==="success"?C.success:C.danger, marginTop:8 }}>{referralMsg.text}</div>}
      </div>

      {/* Cancel */}
      {account.plan!=="free" && (
        <div style={{ textAlign:"center", paddingTop:4, paddingBottom:20 }}>
          <button onClick={function(){ setShowCancel(true); }} style={{ background:"none", border:"none", color:C.muted, fontSize:12, ...FM, cursor:"pointer", textDecoration:"underline" }}>Cancel subscription</button>
        </div>
      )}
    </div>
  );
}

// ─── RESOURCES TAB ────────────────────────────────────────────────────────────

function ResourcesTab(props) {
  var onNavigate = props.onNavigate || function(){};
  var links = [
    { icon:"📖", title:"Getting Started Guide",     sub:"Set up your fleet in 5 minutes",           color:C.accent, page:null },
    { icon:"🎬", title:"Video Walkthrough",          sub:"Full app tour — 8 minutes",                color:C.blue, page:null },
    { icon:"🔧", title:"Adding Equipment",           sub:"Step-by-step for any equipment type",      color:C.teal, page:null },
    { icon:"👥", title:"Managing Crew",              sub:"Roles, permissions, and invites",          color:C.purple, page:null },
    { icon:"📊", title:"Reading Your Reports",       sub:"Make sense of your maintenance data",      color:C.success, page:null },
    { icon:"📧", title:"Contact Support",            sub:"support@mychorehabit.com",                   color:C.accent, page:"support" },
    { icon:"💬", title:"Feature Requests",           sub:"Tell us what to build next",               color:C.purple, page:"support" },
    { icon:"📋", title:"Terms of Service",           sub:"Last updated March 2026",                  color:C.muted, page:"terms" },
    { icon:"🔒", title:"Privacy Policy",             sub:"How we handle your data",                  color:C.muted, page:"privacy" },
  ];
  return (
    <div style={{ paddingBottom:40 }}>
      <div style={{ background:C.accentDim, border:"1px solid "+C.accent, borderRadius:14, padding:"16px 18px", marginBottom:16 }}>
        <div style={{ fontSize:13, fontWeight:700, color:C.accent, marginBottom:4 }}>Never Fall Behind.</div>
        <div style={{ fontSize:12, color:C.dim, lineHeight:1.6 }}>ChoreHabit keeps your equipment running and your crew on the same page. Questions? We're here.</div>
      </div>
      {links.map(function(link) {
        return (
          <div key={link.title} style={{ background:C.surface, border:"1px solid "+C.border, borderRadius:12, padding:"14px 16px", marginBottom:8, display:"flex", alignItems:"center", gap:12, cursor:"pointer" }}
            onClick={function(){ if(link.page) onNavigate(link.page); else if(link.title==="Contact Support") window.location.href="mailto:support@mychorehabit.com"; }}>
            <div style={{ width:42, height:42, background:"rgba(255,255,255,0.04)", borderRadius:10, display:"flex", alignItems:"center", justifyContent:"center", fontSize:22, flexShrink:0 }}>{link.icon}</div>
            <div style={{ flex:1 }}>
              <div style={{ fontSize:13, fontWeight:700, color:C.text }}>{link.title}</div>
              <div style={{ fontSize:11, color:C.muted, marginTop:2 }}>{link.sub}</div>
            </div>
            <div style={{ fontSize:16, color:link.color }}>{">"}</div>
          </div>
        );
      })}
      <div style={{ textAlign:"center", marginTop:20, fontSize:11, color:C.muted, lineHeight:1.8 }}>
        ChoreHabit v1.0<br/>
        © 2026 MyChoreHabit LLC<br/>
        Made in eastern Idaho 🥔
      </div>
    </div>
  );
}

// ─── ACCOUNT SCREEN ROOT ─────────────────────────────────────────────────────


// ─── CREW TAB ─────────────────────────────────────────────────────────────────

function CrewTab(props) {
  var account = props.account || {};
  var currentUser = props.currentUser || {};
  var plan = account.plan || "free";
  var CREW_PLANS = ["captain","pro"];
  var hasCrew = CREW_PLANS.indexOf(plan) >= 0;

  var c1=useState(""); var inviteName=c1[0]; var setInviteName=c1[1];
  var c2=useState(""); var inviteEmail=c2[0]; var setInviteEmail=c2[1];
  var c3=useState("idle"); var inviteStatus=c3[0]; var setInviteStatus=c3[1];
  var c4=useState(null); var inviteError=c4[0]; var setInviteError=c4[1];
  var c5=useState([]); var crewList=c5[0]; var setCrewList=c5[1];
  var c6=useState(true); var loading=c6[0]; var setLoading=c6[1];

  // Inline useEffect equivalent — load crew on mount
  var c7=useState(false); var loaded=c7[0]; var setLoaded=c7[1];
  if (!loaded && hasCrew && currentUser.company_id) {
    setLoaded(true);
    supabase.from("profiles")
      .select("id, full_name, email, tutorial_complete, created_at")
      .eq("company_id", currentUser.company_id)
      .eq("role", "crew")
      .then(function(res){ setCrewList(Array.isArray(res.data)?res.data:[]); setLoading(false); })
  }

  function sendInvite() {
    if (!inviteEmail.trim()) { setInviteError("Email is required"); return; }
    setInviteStatus("sending"); setInviteError(null);
    fetch("/.netlify/functions/invite-crew", {
      method:"POST",
      headers:{"Content-Type":"application/json"},
      body:JSON.stringify({
        email: inviteEmail.trim(),
        fullName: inviteName.trim(),
        companyId: currentUser.company_id,
        invitedBy: currentUser.name || currentUser.email,
      })
    })
    .then(function(r){ return r.json(); })
    .then(function(data){
      if (data.error) { setInviteError(data.error); setInviteStatus("idle"); return; }
      setInviteStatus("sent");
      setCrewList(function(list){ return list.concat([{ id:data.userId, full_name:inviteName.trim()||inviteEmail.trim(), email:inviteEmail.trim(), tutorial_complete:false }]); });
      setInviteName(""); setInviteEmail("");
      setTimeout(function(){ setInviteStatus("idle"); }, 3000);
    })
    .catch(function(){ setInviteError("Invite failed. Check your connection."); setInviteStatus("idle"); });
  }

  var maxCrew = plan==="captain"?4:plan==="pro"?null:0;

  if (!hasCrew) {
    return (
      <div style={{ paddingBottom:40 }}>
        <div style={{ background:C.purpleDim, border:"1px solid "+C.purple, borderRadius:14, padding:"24px 20px", textAlign:"center" }}>
          <div style={{ fontSize:28, marginBottom:12 }}>👥</div>
          <div style={{ fontSize:14, fontWeight:700, color:C.purple, marginBottom:8 }}>Crew features require Captain & Crew or Pro</div>
          <div style={{ fontSize:12, color:C.dim, lineHeight:1.7, marginBottom:20 }}>Invite crew members to log hours, submit service requests, and flag issues from the field — all visible on your admin dashboard in real time.</div>
          <div style={{ fontSize:13, fontWeight:700, color:C.accent }}>Captain & Crew — $39.99/mo</div>
          <div style={{ fontSize:11, color:C.dim, marginTop:4 }}>1 admin + 4 crew · 25 equipment · All features</div>
        </div>
      </div>
    );
  }

  return (
    <div style={{ paddingBottom:80 }}>
      {/* Current crew */}
      <div style={{ background:C.surface, border:"1px solid "+C.border, borderRadius:14, padding:"18px 16px", marginBottom:12 }}>
        <div style={{ fontSize:11, color:C.accent, fontWeight:700, letterSpacing:"0.15em", textTransform:"uppercase", marginBottom:14 }}>
          Your Crew {maxCrew ? "("+crewList.length+"/"+maxCrew+")" : "("+crewList.length+")"}
        </div>
        {loading && <div style={{ fontSize:12, color:C.muted, ...FM }}>Loading crew...</div>}
        {!loading && crewList.length===0 && (
          <div style={{ fontSize:12, color:C.muted, lineHeight:1.6 }}>No crew members yet. Invite someone below to get started.</div>
        )}
        {crewList.map(function(member) {
          return (
            <div key={member.id} style={{ display:"flex", alignItems:"center", gap:12, background:C.surfaceHi, borderRadius:10, padding:"12px 14px", marginBottom:8 }}>
              <div style={{ width:36, height:36, borderRadius:"50%", background:C.accentDim, border:"1px solid "+C.accent, display:"flex", alignItems:"center", justifyContent:"center", fontSize:14, fontWeight:700, color:C.accent, flexShrink:0 }}>
                {(member.full_name||member.email||"?")[0].toUpperCase()}
              </div>
              <div style={{ flex:1 }}>
                <div style={{ fontSize:13, fontWeight:700, color:C.text }}>{member.full_name||member.email}</div>
                <div style={{ fontSize:10, color:C.muted, marginTop:2 }}>{member.email}</div>
              </div>
              <div style={{ fontSize:10, ...FM, fontWeight:700, textTransform:"uppercase", letterSpacing:"0.06em", color:member.tutorial_complete?C.success:C.muted }}>
                {member.tutorial_complete?"Active":"Pending"}
              </div>
            </div>
          );
        })}
      </div>

      {/* Invite form */}
      {(!maxCrew || crewList.length < maxCrew) && (
        <div style={{ background:C.surface, border:"1px solid "+C.border, borderRadius:14, padding:"18px 16px", marginBottom:12 }}>
          <div style={{ fontSize:11, color:C.blue, fontWeight:700, letterSpacing:"0.15em", textTransform:"uppercase", marginBottom:14 }}>Invite a Crew Member</div>
          {inviteStatus==="sent" ? (
            <div style={{ background:C.successDim, border:"1px solid "+C.success, borderRadius:10, padding:"14px 16px", textAlign:"center" }}>
              <div style={{ fontSize:20, marginBottom:8 }}>✅</div>
              <div style={{ fontSize:13, fontWeight:700, color:C.success }}>Invite sent!</div>
              <div style={{ fontSize:11, color:C.dim, marginTop:4 }}>They'll receive an email to set up their account.</div>
            </div>
          ) : (
            <div>
              <div style={{ marginBottom:12 }}>
                <label style={lbl}>Full Name</label>
                <input style={inp} placeholder="Tom W." value={inviteName} onChange={function(e){ setInviteName(e.target.value); }} />
              </div>
              <div style={{ marginBottom:12 }}>
                <label style={lbl}>Email Address *</label>
                <input style={inp} type="email" placeholder="tom@company.com" value={inviteEmail} onChange={function(e){ setInviteEmail(e.target.value); setInviteError(null); }} />
              </div>
              {inviteError && <div style={{ fontSize:11, color:C.danger, ...FM, marginBottom:10 }}>{inviteError}</div>}
              <button
                onClick={sendInvite}
                disabled={inviteStatus==="sending"||!inviteEmail.trim()}
                style={{ width:"100%", background:inviteStatus==="sending"||!inviteEmail.trim()?C.surfaceHi:C.blue, border:"none", borderRadius:10, color:inviteStatus==="sending"||!inviteEmail.trim()?C.muted:"#fff", fontSize:12, ...FM, fontWeight:700, padding:12, cursor:inviteStatus==="sending"||!inviteEmail.trim()?"not-allowed":"pointer", textTransform:"uppercase", letterSpacing:"0.08em" }}
              >
                {inviteStatus==="sending"?"Sending...":"Send Invite →"}
              </button>
              <div style={{ fontSize:10, color:C.muted, marginTop:8, lineHeight:1.6, ...FM }}>
                They'll receive an email with a link to set up their account. They'll be guided through a quick tutorial before seeing crew view.
              </div>
            </div>
          )}
        </div>
      )}

      {maxCrew && crewList.length >= maxCrew && (
        <div style={{ background:C.accentDim, border:"1px solid "+C.accent, borderRadius:12, padding:"14px 16px", marginBottom:12 }}>
          <div style={{ fontSize:12, fontWeight:700, color:C.accent, marginBottom:4 }}>Crew limit reached</div>
          <div style={{ fontSize:11, color:C.dim, lineHeight:1.6 }}>You have {maxCrew} crew members on Captain & Crew. Upgrade to Pro for unlimited crew.</div>
        </div>
      )}
    </div>
  );
}

export default function AccountScreen(props) {
  var onBack = props.onBack || function(){};
  var onLogout = props.onLogout || function(){};
  var onDeleteAccount = props.onDeleteAccount || function(){};
  var onNavigate = props.onNavigate || function(){};
  var currentUser = props.currentUser || {};

  var t1=useState("company"); var activeTab=t1[0]; var setActiveTab=t1[1];
  var t2=useState({
    companyName: props.companyName || currentUser.company || "My Operation",
    ownerName:   currentUser.name  || "",
    email:       currentUser.email || "",
    industry:    props.industry    || "",
    phone:"", address:"", city:"", state:"", zip:"",
    timezone:"America/Denver",
    plan:        currentUser.plan  || "free",
    billing:     currentUser.billing || "monthly",
    isFoundingMember: false,
    foundingSpotsLeft: 3,
    nextBillingDate: "2026-05-06",
    referralCode: (currentUser.company||"CHOREHABIT").toUpperCase().replace(/\s/g,"").slice(0,10),
    referralCredits: 0,
  }); var account=t2[0]; var setAccount=t2[1];

  var css = "@import url('https://fonts.googleapis.com/css2?family=DM+Mono:wght@400;500&display=swap'); *{box-sizing:border-box;margin:0;padding:0;} input:focus,select:focus,textarea:focus{border-color:#F5A623!important;outline:none;} ::-webkit-scrollbar{width:4px;} ::-webkit-scrollbar-thumb{background:#2E3248;border-radius:2px;} button:hover{opacity:0.88;}";

  var TABS = [
    {key:"company", label:"Company"},
    {key:"account", label:"Account"},
    {key:"crew", label:"Crew"},
    {key:"subscription", label:"Billing"},
    {key:"resources", label:"Resources"},
  ];

  return (
    <div style={{ ...FM, background:C.bg, minHeight:"100vh", color:C.text, display:"flex", flexDirection:"column", alignItems:"center" }}>
      <style>{css}</style>
      <div style={{ width:"100%", maxWidth:480 }}>
        {/* Header */}
        <div style={{ padding:"18px 20px 0", display:"flex", alignItems:"center", gap:12, borderBottom:"1px solid "+C.border, paddingBottom:16 }}>
          <button onClick={onBack} style={{ background:"none", border:"none", color:C.blue, fontSize:22, cursor:"pointer", padding:"0 6px 0 0", lineHeight:1 }}>{"<"}</button>
          <div style={{ flex:1 }}>
            <div style={{ fontSize:13, fontWeight:700, color:C.accent, letterSpacing:"0.15em", textTransform:"uppercase" }}>Account Settings</div>
            <div style={{ fontSize:11, color:C.muted, marginTop:2 }}>{account.companyName}</div>
          </div>
          <button onClick={onLogout} style={{ background:"none", border:"1px solid "+C.border, borderRadius:8, color:C.muted, fontSize:10, ...FM, fontWeight:700, padding:"6px 12px", cursor:"pointer", textTransform:"uppercase", letterSpacing:"0.06em" }}>Sign Out</button>
        </div>

        {/* Tab bar */}
        <div style={{ display:"flex", gap:4, padding:"10px 16px 0", background:C.bg, borderBottom:"1px solid "+C.border }}>
          {TABS.map(function(tab) {
            var active=activeTab===tab.key;
            return (
              <button key={tab.key} onClick={function(){ setActiveTab(tab.key); }} style={{ flex:1, background:"none", border:"none", borderBottom:"2px solid "+(active?C.accent:"transparent"), color:active?C.accent:C.muted, fontSize:10, ...FM, fontWeight:active?700:400, padding:"6px 4px 10px", cursor:"pointer", textTransform:"uppercase", letterSpacing:"0.08em", transition:"all 0.2s" }}>{tab.label}</button>
            );
          })}
        </div>

        {/* Tab content */}
        <div style={{ padding:"16px 16px 0" }}>
          {activeTab==="company"      && <CompanyTab      account={account} onSave={setAccount} />}
          {activeTab==="account"      && <AccountTab      account={account} onSave={setAccount} onDeleteAccount={onDeleteAccount} />}
          {activeTab==="crew"         && <CrewTab         account={account} currentUser={currentUser} />}
          {activeTab==="subscription" && <SubscriptionTab account={account} onSave={setAccount} currentUser={currentUser} />}
          {activeTab==="resources"    && <ResourcesTab onNavigate={onNavigate} />}
        </div>
      </div>
    </div>
  );
}
